/** SA6 — catálogo de reportes Super Admin (espejo de core/admin_reports.py). */

export const REPORT_VERTICALS = [
  { key: 'todas', label: 'Todas' },
  { key: 'inmobiliaria', label: 'Inmobiliaria' },
  { key: 'desarrollos', label: 'Desarrollos' },
  { key: 'autos', label: 'Autos' },
];

export const KPI_META = {
  total_users: { label: 'Usuarios', color: 'cyan' },
  total_leads: { label: 'Leads', color: 'emerald' },
  total_properties: { label: 'Propiedades', color: 'amber' },
  total_wa_messages: { label: 'Mensajes WA', color: 'green' },
  total_opportunities: { label: 'Oportunidades', color: 'violet' },
  total_developments: { label: 'Desarrollos', color: 'violet' },
  total_units: { label: 'Unidades', color: 'amber' },
  total_car_models: { label: 'Modelos', color: 'amber' },
};

const KPIS = {
  todas: ['total_users', 'total_leads', 'total_properties', 'total_wa_messages'],
  inmobiliaria: ['total_leads', 'total_properties', 'total_opportunities', 'total_wa_messages'],
  desarrollos: ['total_developments', 'total_units', 'total_leads', 'total_opportunities'],
  autos: ['total_car_models', 'total_leads', 'total_opportunities'],
};

const ACTIVITY_30D = {
  todas: [
    { key: 'leads_30d', label: 'Leads creados', color: 'emerald' },
    { key: 'properties_30d', label: 'Propiedades', color: 'amber' },
    { key: 'wa_messages_30d', label: 'Mensajes WA', color: 'green' },
  ],
  inmobiliaria: [
    { key: 'leads_30d', label: 'Leads creados', color: 'emerald' },
    { key: 'properties_30d', label: 'Propiedades', color: 'amber' },
    { key: 'wa_messages_30d', label: 'Mensajes WA', color: 'green' },
  ],
  desarrollos: [
    { key: 'leads_30d', label: 'Leads creados', color: 'emerald' },
  ],
  autos: [
    { key: 'leads_30d', label: 'Leads creados', color: 'emerald' },
  ],
};

export function normalizarVertical(raw) {
  const v = String(raw || 'todas').toLowerCase();
  return KPIS[v] ? v : 'todas';
}

export function kpisPara(vertical) {
  return KPIS[normalizarVertical(vertical)];
}

export function activity30dPara(vertical) {
  return ACTIVITY_30D[normalizarVertical(vertical)];
}

export function btypeLabel(bt) {
  if (bt === 'agency') return 'Agencia';
  if (bt === 'developer') return 'Desarrollador';
  if (bt === 'independent') return 'Independiente';
  if (bt === 'franchise') return 'Franquicia';
  if (bt === 'car_dealer') return 'Autos';
  return bt || '—';
}
